export enum ClientBalanceStatus {
    Neutral = 0,
    Creditor = 1,
    Debtor = 2
}